import { formatDuration } from "@/lib/time-utils";
import { TimeEntryRow } from "./TimeEntryRow";
import type { DayGroup } from "@/lib/time-utils";
import type { TimeEntry } from "@/types/time";

interface TimeEntryDayGroupProps {
  group: DayGroup;
  onEdit?: (entry: TimeEntry) => void;
  onDelete?: (id: string) => void;
}

export function TimeEntryDayGroup({
  group,
  onEdit,
  onDelete,
}: TimeEntryDayGroupProps) {
  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <h3 className="text-sm font-medium">
          {group.label}
          <span className="ml-2 text-xs font-normal text-muted-foreground/60">
            {group.fullDate}
          </span>
        </h3>
        <span className="text-sm text-muted-foreground">
          {formatDuration(group.totalSeconds)}
        </span>
      </div>
      <div className="space-y-1">
        {group.entries.map((entry) => (
          <TimeEntryRow
            key={entry.id}
            entry={entry}
            onEdit={onEdit}
            onDelete={onDelete}
          />
        ))}
      </div>
    </div>
  );
}
